import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RcSlider from 'rc-slider';

import { LocaleService, ContentZonesService, WindowProxy } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import generateHandleWithTaxSavings from 'trade-in/components/EstimateTradeIn/components/Slider/HandleWithTooltip.jsx';
import './Slider.scss';

const czGroup = 'widget.tradein.teaser';

class Slider extends Component {
    componentDidMount() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            const handle = windowProxy.document.getElementsByClassName('rc-slider-handle')[0];
            if (handle) {
                handle.addEventListener('touchstart', () => handle.classList.add('active'));
                handle.addEventListener('touchend', () => handle.classList.remove('active'));
                handle.addEventListener('touchcancel', () => handle.classList.remove('active'));
            }
        }
    }

    render() {
        const { tradeInValues, handleRangeChange, handleEstimateChange } = this.props;
        const defaultHighValueCz = '#1DD1A1';
        const defaultLowValueCz = '#EB3B5A';
        const highValueCz = ContentZonesService.getContentZone(czGroup, 'estimate.value.high.color');
        const lowValueCz = ContentZonesService.getContentZone(czGroup, 'estimate.value.low.color');
        const lowColor = lowValueCz ? lowValueCz.getValue() : defaultLowValueCz;
        const highColor = highValueCz ? highValueCz.getValue() : defaultHighValueCz;
        const rcSliderStyle = `.rc-slider {
            background: ${lowColor};
            background: -moz-linear-gradient(left, ${lowColor} 0%, ${highColor} 100%);
            background: -webkit-linear-gradient(left, ${lowColor} 0%,${highColor} 100%);
            background: linear-gradient(to right, ${lowColor} 0%,${highColor} 100%);
        }`;

        const taxSavings = Math.round(tradeInValues.amount * tradeInValues.taxesFactor);

        return (
            <div className="slider__content--wrapper" ontouchstart>
                <style>{rcSliderStyle}</style>
                <div className="slider__content--value  low-value" style={{ color: lowColor }}>
                    <span className="is-bold" data-test="trade-in.slider.low-value">
                        {LocaleService.l(tradeInValues.low, CurrencyFormats.CURRENCY_0)}
                    </span>
                    <span className="slider__content--value--label is-uppercase is-light sr-disclaimer">
                        {LocaleService.t('TRADE_IN.ESTIMATE.VALUE.LOW.TITLE')}
                    </span>
                </div>
                <RcSlider
                    range={0}
                    min={tradeInValues.low}
                    max={tradeInValues.high}
                    onChange={handleRangeChange}
                    onAfterChange={handleEstimateChange}
                    step={1}
                    defaultValue={tradeInValues.low + (tradeInValues.high - tradeInValues.low) / 2}
                    handle={generateHandleWithTaxSavings(taxSavings, tradeInValues.amount)}
                />
                <div className="slider__content--value high-value" style={{ color: highColor }}>
                    <span className="is-bold" data-test="trade-in.slider.high-value">
                        {LocaleService.l(tradeInValues.high, CurrencyFormats.CURRENCY_0)}
                    </span>
                    <span className="slider__content--value--label is-uppercase is-light sr-disclaimer">
                        {LocaleService.t('TRADE_IN.ESTIMATE.VALUE.HIGH.TITLE')}
                    </span>
                </div>
            </div>
        );
    }
}

Slider.propTypes = {
    tradeInValues: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        high: PropTypes.number.isRequired,
        low: PropTypes.number.isRequired,
        taxesFactor: PropTypes.number.isRequired,
    }).isRequired,
    handleRangeChange: PropTypes.func.isRequired,
    handleEstimateChange: PropTypes.func.isRequired,
};

export default Slider;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/components/Slider/Slider.jsx